<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a component') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="component">{{ _('Component') }}</label><br />
            <select class="form-control" v-model="componentId">
              <option v-for="c in components" :value="c.id">{{ c.id }}: {{ c.name }} ({{ c.type }})</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="addComponent"><i class="fa fa-fw fa-plus"></i> {{ _('Add component') }}</button>
      <button class="btn btn-success" v-on:click="selectComponent"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      componentId: null,
      components: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    addComponent () {
      this.$emit('addComponent')
    },
    selectComponent () {
      this.$emit('selectComponent', this.componentId)
    },
  },
  async mounted () {
    let response
    try {
      response = await axios.get(this.baseDomain + this.shopId + '/components.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
    } catch(e) {}
    this.components = response.data
  }
}
</script>